// extracted by mini-css-extract-plugin
export default {"goal":"Goal_goal__WyvIz","icon":"Goal_icon__u0t3b","bar1":"Goal_bar1__zbPbH","bar2":"Goal_bar2__E0CZt"};